// extracted by mini-css-extract-plugin
export default {"btn":"Switch_btn__oLss0"};